export var TransactionState;
(function (TransactionState) {
    TransactionState["INITIAL"] = "INITIAL";
    TransactionState["PENDING"] = "PENDING";
    TransactionState["SUCCESSFUL"] = "SUCCESSFUL";
    TransactionState["FAILED"] = "FAILED";
})(TransactionState || (TransactionState = {}));
